<template>
  <b-form class="py-4">
    <b-form-row>
      <b-col class="mx-2" style="text-align: center !important">
        <span class="sg-sub-heading-text">
          Create Account
        </span>
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="5">
        <b-form-input
          v-model="user.first_name"
          id='input-first-name'
          placeholder="First Name"
          type="text"
        />
      </b-col>
      <b-col cols="5">
        <b-form-input
          v-model="user.last_name"
          id='input-last-name'
          placeholder="Last Name"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="10">
        <b-form-input
          v-model="user.email"
          id='input-email'
          placeholder="Email"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="5">
        <b-form-input
          v-model="user.password"
          id="input-password"
          placeholder="Password"
          type="password"
        />
      </b-col>
      <b-col cols="5">
        <b-form-input
          v-model="user.confirm_password"
          id="input-confirm-password"
          placeholder="Confirm Password"
          type="password"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-4">
      <b-col cols="6">
        <b-button variant="success" block @click="createCS" :disabled="register_button_state">
          Register
        </b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component

// api call
import UserAPI from '@/api/UserAPI'

export default {
  name: 'FormRegisterCustomer',
  components: {
  },
  data () {
    return {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: ''
      },

      register_button_state: false,
      errors: []
    }
  },
  methods: {
    // PREREQUISITES
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    childData: function (id, value) {
      // catch value from custom form template
      this.user[id] = value
    },
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null
    },
    // END PREREQUISITES

    // HTTP REQUEST
    createCS: async function () {
      this.register_button_state = true
      this.errors = []

      if (this.isEmptyOrSpaces(this.user.first_name)) this.errors.push('First name is Required.')
      if (this.isEmptyOrSpaces(this.user.last_name)) this.errors.push('Last name is Required.')
      if (this.isEmptyOrSpaces(this.user.email)) this.errors.push('Email is Required.')
      else if (!this.validEmail(this.user.email)) this.errors.push('Invalid email format.')
      if (this.isEmptyOrSpaces(this.user.password)) this.errors.push('You need to fill the password field.')
      if (this.isEmptyOrSpaces(this.user.confirm_password)) this.errors.push('You forget to fill confirmation password.')
      if (this.isEmptyOrSpaces(this.user.confirm_password)) this.errors.push('You forget to fill confirmation password.')
      if (this.user.password !== this.user.confirm_password) this.errors.push('Password is not match.')

      if (this.errors.length) {
        swal({
          title: 'Please check your input.',
          text: this.errors[0],
          icon: 'error',
          button: {
            text: 'Ok'
          },

          closeOnClickOutside: false,
          closeOnEsc: false
        })

        this.register_button_state = false
      } else {
        try {
          await UserAPI.createCS(this.user)

          this.$router.push({ name: 'Support_RegisterComplete' })
        } catch (error) {
          let msg = error.response.data

          swal({
            title: 'Failed',
            text: msg,
            icon: 'error',
            button: {
              text: 'Ok'
            },

            closeOnClickOutside: false,
            closeOnEsc: false
          })

          this.register_button_state = false
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scope>
  .sg-sub-heading-text {
    color: #233c7c;
    font-size: 32px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/templates/FormRegisterCustomer/FormRegisterCustomer.vue